import React, {ReactNode} from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {Modal} from "react-bootstrap";
import {ReactComponent as LeftIco} from "../../../../../images/icons/arrow-left.svg";
import {RootState} from "../../../../../reducers";


interface OwnProps {
    back: any,
    onHide: () => void,
    title: any,
    children?: ReactNode
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const MenuShowItemModalComponent = ({back, onHide, title, children}:Props) => {
    const {t} = useTranslation();

    return (
        <>
            {back ? (
                <Modal.Header className={"modal-header-back"}>
                    <a className={"back-icon text-primary"} href={"#"} onClick={() => onHide()}>
                        <LeftIco className="icon"/>
                    </a>
                    <Modal.Title id="menu_item_base_modal_title">
                        {title}
                    </Modal.Title>
                </Modal.Header>
            ) : (
                <Modal.Header>
                    <Modal.Title id="menu_item_base_modal_title">
                        {title}
                    </Modal.Title>
                    <button onClick={onHide} className="btn-close" data-bs-dismiss="modal"
                            aria-label={t("common.action.close")} />
                </Modal.Header>
            )}
            <Modal.Body>
                {children}
            </Modal.Body>
        </>
    )

}

const mapStateToProps = (state: RootState) => ({
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuShowItemModalComponent));